import styled from "@emotion/styled";
import { useField } from "formik";
import TextareaAutosize from "react-textarea-autosize";

import { useFieldContext } from "../FormFieldContext";
import { useBlurOnEnterKey, useFieldPlaceholder, useHandleBlur } from "./helpers";

export const ResizingTextarea = styled(TextareaAutosize)`
  padding: 8px;
  border-radius: 2px;

  overflow: hidden;
  resize: none;
`;

type FieldResizingTextareaProps = Omit<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  "id" | "name" | "value" | "style" | "css" | "onBlur" | "onChange" | "onKeyPress"
>;

export const FieldResizingTextarea = (props: FieldResizingTextareaProps) => {
  const { controlId, dataTest, name } = useFieldContext();
  const [{ value, onChange }] = useField(name);

  const fieldPlaceholder = useFieldPlaceholder(name);

  const handleBlur = useHandleBlur();
  const handleBlurOnEnterKey = useBlurOnEnterKey();

  return (
    <ResizingTextarea
      {...props}
      id={controlId}
      name={name}
      placeholder={props.placeholder ?? fieldPlaceholder}
      value={value}
      onBlur={handleBlur}
      onChange={onChange}
      onKeyPress={handleBlurOnEnterKey}
      data-test={`${dataTest ?? name}-textarea`}
    />
  );
};
